import React, { Component } from "react";

export default class Impressum extends Component {
  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "instant" });
  }

  render() {
    return (
      <div className="container">
        <div className="padding-block-500">
          <div className="misc-heading">Impressum</div>
          <br />
          <div className="misc-paragraph">
            <h3 className="fw-bold">Angaben gemäß § 5 TMG:</h3>
            <p>Gesundheitssportverein Epikur e.V.</p>
            <p>Vorstandsvorsitzender: Uwe Schrader</p>
            <p>Südring 6, 04924 Bad Liebenwerda</p>
            <p>Tel.: 035341/4772-0</p>
            <p>info@epikur-zentrum.de</p>
            <br />
            <p>VR 4511 CB</p>
            <p>Registergericht: Cottbus</p>
            <br />
            <h2 className="fw-bold">Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a href="https://ec.europa.eu/consumers/odr">
                https://ec.europa.eu/consumers/odr
              </a>
              .
            </p>
            <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
            <br />
            <h3 className="fw-bold">Haftung für Inhalte</h3>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
              jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die
              auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <br />
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon
              unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
              Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
              Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
              diese Inhalte umgehend entfernen.
            </p>
            <br />
            <h3 className="fw-bold">Haftung für Links</h3>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
              wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
              überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
              Verlinkung nicht erkennbar.
            </p>
            <br />
            <p>
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
              jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
              zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
              derartige Links umgehend entfernen.
            </p>
            <br />
            <h3 className="fw-bold">Urheberrecht</h3>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht
              kommerziellen Gebrauch gestattet.
            </p>
            <br />
            <p>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
              wurden, werden die Urheberrechte Dritter beachtet. Insbesondere
              werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie
              trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
              bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
              Rechtsverletzungen werden wir derartige Inhalte umgehend
              entfernen.
            </p>
          </div>
          <br />
          <div className="padding-block-700">
            <h3 className="fw-bold">Lizenzierte Bilder</h3>
            <p>©JackF / #487684910 – stock.adobe.com.</p>
            <p>©JackF / #614649856 – stock.adobe.com.</p>
            <p>©Photographee.eu / #277230029 – stock.adobe.com.</p>
            <p>©NDABCREATIVITY / #233158793 – stock.adobe.com.</p>
            <p>©Somkiat / #192189854 – stock.adobe.com.</p>
            <p>©wutzkoh / #279455077 – stock.adobe.com.</p>
            <p>©Prostock-studio / #657314659 – stock.adobe.com.</p>
            <p>©NDABCREATIVITY / #177817667 – stock.adobe.com.</p>
            <p>
              ©Kay Abrahams/peopleimages.com / #536581094 – stock.adobe.com.
            </p>
            <p>©Syda Productions / #158886042 – stock.adobe.com.</p>
            <p>©Viacheslav Yakobchuk / #148812895 – stock.adobe.com.</p>
          </div>
        </div>
      </div>
    );
  }
}
